export const LANDING_THEMES = {
  prosperity: {
    primary: '#0C1F35',
    accent: '#00AAFF',
    accent2: '#FFC72C',
    ctaText: '#FFFFFF',
  },
  mujeres: {
    primary: '#3C1B4A',
    accent: '#D4537E',
    accent2: '#F0997B',
    ctaText: '#FFFFFF',
  },
  fintech: {
    primary: '#0B1F3A',
    accent: '#1F6FB2',
    accent2: '#B8C4CE',
    ctaText: '#FFFFFF',
  },
};

export const THEME_OPTIONS = [
  { value: 'prosperity', label: 'Prosperity' },
  { value: 'mujeres', label: 'Mujeres y Riquezas' },
  { value: 'fintech', label: 'Fintech' },
];

export const DENSITY_OPTIONS = [
  { value: 'compact', label: 'Compact' },
  { value: 'full', label: 'Full' },
];

export const HERO_STYLE_OPTIONS = [
  { value: 'form', label: 'Embedded Form' },
  { value: 'image_cta', label: 'Image + CTA' },
];

export function resolveTheme(themeKey) {
  return LANDING_THEMES[themeKey] ?? LANDING_THEMES.prosperity;
}

export function themeStyleVars(themeKey) {
  const t = resolveTheme(themeKey);
  return {
    '--lp-primary': t.primary,
    '--lp-accent': t.accent,
    '--lp-accent-2': t.accent2,
    '--lp-cta-text': t.ctaText,
  };
}
